/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import './style/custom.scss';

import React from 'react';
import {createRoot} from 'react-dom/client';
import App from "./js/app";

const rootElement = document.getElementById('content');
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App/>);
}